// extracted by mini-css-extract-plugin
module.exports = {"dl":"ConfirmationComponent_dl__3-0Gg","feedback":"ConfirmationComponent_feedback__1i8wS","ledger":"ConfirmationComponent_ledger__2YxgL"};